import { render, staticRenderFns } from "./followContent.vue?vue&type=template&id=7f383113&scoped=true&"
import script from "./followContent.vue?vue&type=script&lang=js&"
export * from "./followContent.vue?vue&type=script&lang=js&"
import style0 from "./followContent.vue?vue&type=style&index=0&id=7f383113&lang=less&scoped=true&"
import style1 from "./followContent.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f383113",
  null
  
)

export default component.exports